import { z } from 'zod';

import { type CoreLocationFrontendFilterOptionsMap } from '../CoreGeneralFilters.types';

import { frontendFilterOptionIdSchema } from './shared.schema';

const locationAttributePayloadSchema = z.object({
  id: z.string(),
  description: z.string(),
});

const locationPayloadSchema = z.object({
  id: z.string(),
  description: z.string(),
  country_id: z.string().nullable(),
  country_desc: z.string().nullable(),
  region_id: z.string().nullable(),
  region_desc: z.string().nullable(),
  location_type_id: z.string().nullable(),
  location_type_desc: z.string().nullable(),
  territory_id: z.string().nullable(),
  territory_desc: z.string().nullable(),
  budget_level: z.string().nullable(),
  city_id: z.string().nullable(),
  city_desc: z.string().nullable(),
});

export const coreLocationsFilterOptionSchema = z.object({
  id: frontendFilterOptionIdSchema,
  endpoint: z.literal('/core/locations'),
  payload: locationPayloadSchema,
});

export const coreLocationsLocationTypesFilterOptionSchema = z.object({
  id: frontendFilterOptionIdSchema,
  endpoint: z.literal('/core/locations/location-types'),
  payload: locationAttributePayloadSchema,
});

export const coreLocationsRegionsFilterOptionSchema = z.object({
  id: frontendFilterOptionIdSchema,
  endpoint: z.literal('/core/locations/regions'),
  payload: locationAttributePayloadSchema,
});

export const coreLocationsCountriesFilterOptionSchema = z.object({
  id: frontendFilterOptionIdSchema,
  endpoint: z.literal('/core/locations/countries'),
  payload: locationAttributePayloadSchema,
});

export const coreLocationsTerritoriesFilterOptionSchema = z.object({
  id: frontendFilterOptionIdSchema,
  endpoint: z.literal('/core/locations/territories'),
  payload: locationAttributePayloadSchema,
});

export const coreLocationsCitiesFilterOptionSchema = z.object({
  id: frontendFilterOptionIdSchema,
  endpoint: z.literal('/core/locations/cities'),
  payload: locationAttributePayloadSchema,
});

export const coreLocationsBudgetLevelsFilterOptionSchema = z.object({
  id: frontendFilterOptionIdSchema,
  endpoint: z.literal('/core/locations/budget-levels'),
  payload: locationAttributePayloadSchema,
});

type CoreLocationFrontendFilterOptionZodSchemaMap = Required<{
  [K in keyof CoreLocationFrontendFilterOptionsMap]: z.ZodSchema<
    NonNullable<CoreLocationFrontendFilterOptionsMap[K]>[number]
  >;
}>;

export const coreLocationsFilterOptionZodSchemaMap: CoreLocationFrontendFilterOptionZodSchemaMap =
  {
    locations: coreLocationsFilterOptionSchema,
    location_types: coreLocationsLocationTypesFilterOptionSchema,
    regions: coreLocationsRegionsFilterOptionSchema,
    countries: coreLocationsCountriesFilterOptionSchema,
    territories: coreLocationsTerritoriesFilterOptionSchema,
    cities: coreLocationsCitiesFilterOptionSchema,
    budget_levels: coreLocationsBudgetLevelsFilterOptionSchema,
  } satisfies CoreLocationFrontendFilterOptionZodSchemaMap;
